// Custom elements


if (!customElements.get('swatch-link')) {
	class SwatchLink extends HTMLElement {
		static data = {}
		static loaded = {};

		constructor() {
			super();
			this.sectionId = document.getElementById('ProductSection-product-template').dataset.sectionId;
			this.init();
		}

		async init() {
			this.addEventListener('mousedown', () => this.loadData());
			this.addEventListener('touchstart', () => this.loadData());
			this.addEventListener('click', e => {
				e.preventDefault();
				this.swap();
			});

			window.addEventListener('load', this.loadData());
		}

		async loadData() {
			if (SwatchLink.data[this.dataset.link]) return;
			SwatchLink.data[this.dataset.link] = fetch(`${this.dataset.link}?section_id=${this.sectionId}`).then(resp => resp.text());
			await SwatchLink.data[this.dataset.link];
			SwatchLink.loaded[this.dataset.link] = true;
		}

		async swap() {
			let section = document.getElementById(`shopify-section-${this.sectionId}`);

			if (!SwatchLink.loaded[this.dataset.link]) {
				section.classList.add('loading');

				if (window.productImagesLightbox) window.productImagesLightbox.destroy();

				document.querySelectorAll('.product__media img').forEach(m => m.src = this.dataset.image);
				document.querySelector('.current_selected_color').innerText = this.dataset.colour;
				document.querySelector('.product__title').innerText = this.dataset.title;

				if (document.querySelector('.current-swatch')) {
					document.querySelector('.current-swatch').classList.remove('current-swatch');
					this.closest('.product-swatch__item').classList.add('current-swatch');
				}
			}

			history.replaceState({}, undefined, this.dataset.link);
			document.title = `${this.dataset.title} – Bed Threads`;

			let data = await SwatchLink.data[this.dataset.link];

			let template = document.createElement('template');
			template.innerHTML = data;

			const existingKlaviyoForm = document.getElementById('pdp-klaviyo-form');

			const selectedOptions = [...document.querySelectorAll('.product-form variant-selector input[type="radio"]:checked')].map(el => el.value);
			let size = document.querySelector(window.innerWidth < 768 ? '.is-mobile .product-size__item.active' : '.product-size__item.active');
			let newSection = template.content;
			let wishlistButtons = document.querySelectorAll('.product-main-wrapper wishlist-add-button');
			
			section.replaceWith(newSection);

			const newKlaviyoForm = document.getElementById('pdp-klaviyo-form');
			if (existingKlaviyoForm && newKlaviyoForm) newKlaviyoForm.replaceWith(existingKlaviyoForm);

			initProductPage();
			window.initSignifier();
			if (window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();

			for (let selectedOption of selectedOptions) {
				let radio = document.querySelector(`.product-form variant-selector input[type="radio"][value="${selectedOption}"]`);
				if (radio) {
					radio.checked = true;
					radio.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}

			// Reload other sections
			for (let section of document.querySelectorAll('.shopify-section')) {
				if (section.id.includes('okendo-reviews-widget') || section.id.includes('nosto') || section.classList.contains('reload-section')) {
					this.reloadSection(section);
				}
			}

			// Replace Nosto tagging if present
			const existingTagging = document.querySelector('.nosto_product');

			if (existingTagging) {
				const resp = await fetch(`${this.dataset.link}?view=blank`);
				const html = await resp.text();
				const doc = new DOMParser().parseFromString(html, 'text/html');

				const newTagging = doc.querySelector('.nosto_product');
				if (newTagging) existingTagging.outerHTML = newTagging.outerHTML;
			}

			if (window.okeWidgetApi) {
					window.okeWidgetApi.initAllWidgets()
			}

			if (window.nostojs) {
				window.nostojs(api => {
					api.createRecommendationRequest({includeTagging:true})
					.setProducts([{product_id: this.dataset.productId}])
					.load();
				});	
			}
		}

		async reloadSection(section) {
			const resp = await fetch(`${this.dataset.link}?section_id=${section.id.replace('shopify-section-', '')}`);
			const html = await resp.text();
			section.outerHTML = html;
		}
	}

	customElements.define('swatch-link', SwatchLink);
}

class BNPLWidget extends HTMLElement {
	connectedCallback() {
		window.addEventListener('pricechanged', e => {
			let price = e.detail.price;
			this.querySelector('.bnpl__price').innerHTML = theme.Currency.formatMoney((price * 100) / 4);
			let afterpayPlacement = this.querySelector('afterpay-placement');
			if (afterpayPlacement) afterpayPlacement.dataset.amount = theme.Currency.formatMoney(price * 100).replace(/[^0-9.]/g, '');
		});

		this.addEventListener('click', e => {
			e.preventDefault();

			// Trigger Afterpay/Clearpay modal
			if (this.dataset.provider == 'clearpay' || this.dataset.provider == 'afterpay') {
				let placement = this.querySelector('afterpay-placement');
				placement.shadowRoot.querySelector('button').click();
			}
			// Trigger Shop Pay modal
			else if (this.dataset.provider == 'shop-pay') {
				let terms = document.querySelector('shopify-payment-terms');
				terms.shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot.querySelector('button').click();
			}
		});
	}
}

customElements.define('bnpl-widget', BNPLWidget);

if (!customElements.get('details-toggle')) {
	class DetailsToggle extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('click', e => {
				let details = this.previousElementSibling;

				if (details.classList.contains('expanded')) this.close();
				else this.open();
			});
		}

		open() {
			let details = this.previousElementSibling;
			details.classList.add('expanded');
			this.classList.add('expanded');
			details.style.maxHeight = `${details.scrollHeight}px`;
		}

		close() {
			let details = this.previousElementSibling;
			details.classList.remove('expanded');
			this.classList.remove('expanded');
			details.style.maxHeight = '';
		}
	}

	customElements.define('details-toggle', DetailsToggle);
}

const initProductPage = () => {
	// Disable size selector for sold out buttons
	for (let option of document.querySelectorAll('#ProductSelect-product-template option')) {
		if (option.dataset.inventory_policy == 'deny' && parseInt(option.dataset.inventory) <= 0) {
			for (let sizeButton of document.querySelectorAll(`.product-size__item[data-target="${option.dataset.name}"]`)) {
				sizeButton.style.pointerEvents = 'none';
				sizeButton.style.opacity = 0.5;
			}
		}
	}

	// Dimensions anchor link
	document.addEventListener('click', e => {
		if (e.target.matches('[href="#dimensions"], [href="#dimensions"] span') == false) return;
		let dimensions = document.getElementById('dimensions');
		let item = dimensions.closest('.product-details-item');
		item.classList.add('open');
		item.querySelector('.details-content').style.display = 'block';
	});

	// OEKO-TEX anchor link
	const checkOeko = () => {
		if (window.location.hash.includes('oeko-tex')) {
			console.log('hash changed');
			const details = document.getElementById('productDetails');
			const item = details.closest('.product-details-item');
			item.querySelector('details-toggle').open();
			item.classList.add('open');
			item.querySelector('.details-content').style.display = 'block';
		}
	}
	
	checkOeko();
	window.addEventListener('hashchange', checkOeko);

	// Add to cart
	const addToCart = async () => {
		let select = document.getElementById('ProductSelect-product-template');
		let qtySelector = document.getElementById('Quantity-product-template');
		let quantity = qtySelector ?  parseInt(qtySelector.value) : 1;
		let option = select.selectedOptions[0];
		let selectedSku = select.selectedOptions[0].getAttribute('data-sku');

		const atcButton = document.getElementById('AddToCart-product-template');
		atcButton.classList.add('loading', 'show-loading', 'show-loading--inverted');
		
		// Remove any existing error messages
		const existingErrorMessage = document.querySelector('.add-to-cart-error');
		if (existingErrorMessage) {
			existingErrorMessage.remove();
		}

		let preOrderNote = document.getElementById('preorder-note');
		let preOrderMonth = preOrderNote && preOrderNote.value.length > 0 ? preOrderNote.dataset.month : null;

		let props = {};
		let ukSizeProp = document.querySelector('.uk-size-note-prop');
		if (ukSizeProp && ukSizeProp.value) props['UK Size Note'] = ukSizeProp.value.replace(/(<([^>]+)>)/gi, "");
        let tontineBValue = document.querySelector('#tontineBValue');
		let tontinePriceVariant = document.querySelector('#tontinePriceVariant');
		if (tontineBValue && tontinePriceVariant) {
			props['_tontinePriceVariant'] = tontinePriceVariant.value;
			props['_tontineBValue'] = tontineBValue.value;
		}

		const handle = option.dataset.productHandle;
		const customProps = Object.entries(window.theme.customProps).find(([key, value]) => handle.includes(key))?.[1];
		if (customProps) props = {...props, ...customProps };

		if (option.dataset.priceTest == "true" && window.getActivePriceTest()) props['_PriceTest'] = window.getActivePriceTest();

		// Selling plan
		const checkedSellingPlanGroup = document.querySelector('.product__selling-plan-group input:checked ~ .product__selling-plan-content select');
		const sellingPlan = checkedSellingPlanGroup ? checkedSellingPlanGroup.selectedOptions[0].value : null;

		const items = [{
			handle: handle,
			variantId: option.value,
			quantity: quantity,
			isBundle: theme.product.isBundle,
			preorderMonth: preOrderMonth,
			properties: props,
			sellingPlan
		}]

		for (const recsCheckbox of document.querySelectorAll('.product-main-wrapper recommended-product-checkbox')) {
			if (recsCheckbox && recsCheckbox.hasAttribute('checked')) {
				const recsProps = props['_PriceTest'] ? { '_PriceTest': props['_PriceTest'] } : {};
				recsProps['_CheckboxAddon'] = true;

				items.push({
					handle: recsCheckbox.getAttribute('handle'),
					variantId: recsCheckbox.getAttribute('variant'),
					quantity: 1,
					isBundle: false,
					properties: recsProps
				});
			}
		}

		const errorMessage = await addAllToCart(items);
		
		if (errorMessage) {
			// Display error message
			const errorElement = document.createElement('div');
			errorElement.className = 'add-to-cart-error';
			errorElement.innerHTML = errorMessage;
			
			// Insert error message above the add to cart button
			const productForm = document.querySelector('.product-form');
			const quantityItem = document.querySelector('.product-form__item--quantity');
			productForm.insertBefore(errorElement, quantityItem);
			
			atcButton.classList.remove('loading', 'show-loading', 'show-loading--inverted');
			return;
		}
		
		let stickyCloseOverlay = document.querySelector('.close_menu_overlay');
		if (stickyCloseOverlay && getComputedStyle(stickyCloseOverlay).display != 'none') {
			stickyCloseOverlay.click();
		}
		
		if (selectedSku.startsWith("BTLF-") || (window.featureEnabled && window.featureEnabled('show-cart')) || window.innerWidth > 992) {
			await window.updateCartDrawer();
			window.showCartDrawer(true);
		} else {
			window.updateCartDrawer();
			window.showCartDrawer();
		}

		atcButton.classList.remove('loading', 'show-loading', 'show-loading--inverted');
		
		if (theme.freeGift.products.includes(option.dataset.productHandle)) {
			atcButton.innerHTML = 'Already in cart';
			atcButton.disabled = true;
			atcButton.dataset.limited = true;
		}

		if (selectedSku.includes('BT-SWATCHCARD')) {
			const atcButton = document.getElementById('AddToCart-product-template');
			atcButton.innerHTML = 'Already in cart';
			atcButton.disabled = true;
		}
	}

	const addToCartButton = document.getElementById('AddToCart-product-template');

	addToCartButton?.addEventListener('click', async e => {
		// Disable if link
		if (e.target.type != "submit" && e.target.type != "button") return;
		e.preventDefault();
		await addToCart();
	});

	if (addToCartButton) addToCartButton.dataset.loaded = true;

	// Buy button
	let buyButton = document.getElementById('BuyButton-product-template');
	if (buyButton) {
		buyButton.addEventListener('click', async e => {
			// Disable if link, or if gift card (separate script handles ATC for that)
			if (e.target.type != "submit" || theme.product.type.includes('Gift Card')) return;
			e.preventDefault();
			let select = document.getElementById('ProductSelect-product-template');
			let qtySelector = document.getElementById('Quantity-product-template');
			let quantity = qtySelector ?  parseInt(qtySelector.value) : 1;
			let option = select.selectedOptions[0];

			e.currentTarget.classList.add('show-loading');

			let preOrderNote = document.getElementById('preorder-note');
			let preOrderMonth = preOrderNote && preOrderNote.value.length > 0 ? preOrderNote.dataset.month : null;

			let props = {};
			let ukSizeProp = document.querySelector('.uk-size-note-prop');
			if (ukSizeProp && ukSizeProp.value) props['UK Size Note'] = ukSizeProp.value.replace(/(<([^>]+)>)/gi, "");

			let items = await buildCartItems({handle: option.dataset.productHandle, variantId: option.value, quantity: quantity, isBundle: theme.product.isBundle, preOrderMonth: preOrderMonth, props: props});
			await window.theme.buyNow(items);
		});
	}

	const checkUkSizing = () => {
		if (Shopify.currency.active == 'GBP') {
			const selected = document.querySelector('select[name="id"]').selectedOptions[0];
			const dataset = {...selected.dataset};
			const sizeEntry = Object.entries(dataset).find(([key, value]) => key.toLowerCase().includes('size'));
			if (sizeEntry) {
				const sizeValue = sizeEntry[1];
				getSizeEquivalent(selected, theme.product.type, sizeValue, false);
			}
		}
	}

	checkUkSizing();

	const variantSelector = document.querySelector('.product-form variant-selector');

	if (variantSelector) variantSelector.preorderAtc = addToCart;
	if (variantSelector) variantSelector.addEventListener('variantchange', e => {
		console.log('variant change', e.target);

		// Remove any existing error messages when variant changes
		const existingErrorMessage = document.querySelector('.add-to-cart-error');
		if (existingErrorMessage) {
			existingErrorMessage.remove();
		}

		const selector = e.target;
		const variant = e.detail.variant;	
		const wrapper = selector.closest('.product-main-wrapper');

		// Set variant ID in URL
		const params = new URLSearchParams(window.location.search);
		params.set('variant', variant.id);
		window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);

		// UK sizing
		checkUkSizing();

		// Update price text
		let priceText = variant.priceText;
		document.querySelector('.product__price').innerHTML = priceText;
        //Update tontine price display
        if (window.TontineApp && window.TontineApp.app) {
          window.TontineApp.app.run()
        }

		// Update loyalty points pill
		const pointsPill = document.querySelector('.points-pill');
		if (pointsPill) pointsPill.dataset.price = variant.price;

		// Update express shipping pill
		const expressPill = document.querySelector('.points-pill--express');
		if (expressPill) expressPill.style.display = variant.status !== 'available' && variant.status !== 'low-stock' ? 'none' : '';

		// Set wishlist button variant
		let wishlistButtons = document.querySelectorAll('.product-main-wrapper wishlist-add-button');
		for (let wishlistButton of wishlistButtons) {
			wishlistButton.dataset.variant = variant.id;
		}

		// Update dimensions if present
		let dimensionsDetail = document.querySelector('.product-details__dimensions .details-content');
		if (dimensionsDetail) dimensionsDetail.innerHTML = variant.dimensionsDetail;

		let dimensions = document.querySelector('.product__dimensions');
		if (dimensions) dimensions.innerHTML = variant.dimensions;

		// Select correct image
		if (variant.image) {
			const thumb = document.querySelector(`.product__thumbnail[data-src="${variant.image}"]`);
			if (thumb) thumb.click();
		}

		// Update preorder/sold out state
		const addToCart = document.getElementById('AddToCart-product-template');

		if (addToCart.dataset.limited != 'true') { // Don't update status if quantity limited, eg loyalty gift
			addToCart.disabled = false;
			const stickyAddToCart = document.getElementById('sticky_ATC_mobile');

			const shippingUsp = wrapper.querySelector('.product-usp--shipping');
			if (shippingUsp) shippingUsp.style.display = '';

			const bisForm = wrapper.querySelector('.product__bis-form');
			if (bisForm) {
				bisForm.style.display = 'none';
				bisForm.querySelector('bis-form').setAttribute('variant', variant.id);
			}

			const preorderNotice = wrapper.querySelector('.preorder-notice');
			preorderNotice.style.display = '';
			preorderNotice.querySelector('.preorder-notice__month').innerHTML = variant.preorderMonth;

			const preorderNoteInput = wrapper.querySelector('#preorder-note');
			preorderNoteInput.value = '';

			if (variant.status == 'sold-out' || variant.status == 'preorder' || variant.status == 'coming-soon') {
				if (shippingUsp) shippingUsp.style.display = 'none';

				if (variant.status == 'coming-soon') {
					addToCart.innerHTML = 'Coming soon';
					addToCart.disabled = true;
				}
				else if (variant.status == 'sold-out') {
					addToCart.innerHTML = 'Sold out';
					addToCart.disabled = true;
					if (bisForm && variant.restocking == "true") bisForm.style.display = '';
				}
				else {
					addToCart.innerHTML = 'Pre-order Now';
					if (stickyAddToCart) stickyAddToCart.innerHTML = 'Pre-order Now';
					preorderNotice.style.display = 'flex';
					preorderNoteInput.dataset.month = variant.preorderMonth;
					preorderNoteInput.value = preorderNoteInput.dataset.template.replace('$month', variant.preorderMonth);
					if (bisForm) bisForm.style.display = '';
				}
			}
			else {
				addToCart.innerHTML = 'Add to Cart';
				if (stickyAddToCart) stickyAddToCart.innerHTML = 'Add to Cart';
			}
		}

		// Show variant inclusions
		for (let inclusions of wrapper.querySelectorAll('.product__variant-inclusions')) {
			inclusions.classList.remove('active');
			if (inclusions.dataset.id == variant.id) inclusions.classList.add('active');
		}

		// Restocking tag
		wrapper.dataset.restocking = variant.restocking;
	});


	// Force re-enable BNPL snippet for Shopify buy button if displaying Shop Pay in US
	(() => {
		if (theme.storeLocation !== 'US') return;

		let observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				if (mutation.target.dataset.testid == 'ShopifyPay-button') {
					document.querySelector('bnpl-widget').style.display = 'flex';
				}
			});
		});

		let paymentButton = document.querySelector('.product__payment-button');
		if (paymentButton) {
			observer.observe(paymentButton, {attributes: true, subtree: true, childList: true});
		};
	})();

	// product-template-js.liquid + product-js-files.liquid
	(() => {
		jQuery('.increase.items').on('click', function (e) {
			e.preventDefault();
			var currentValue = parseInt(jQuery(this).siblings('input').val());

			if (currentValue) {
				jQuery(this).siblings('input').val(currentValue + 1);
			} else {
				jQuery(this).siblings('input').val(1);
			}
			checkInventoryQuantity('increase');
		});
		jQuery('.reduced.items').on('click', function (e) {
			e.preventDefault();
			var currentValue = parseInt(jQuery(this).siblings('input').val());

			if (currentValue > 1) {
				jQuery(this).siblings('input').val(currentValue - 1);
			} else {
				jQuery(this).siblings('input').val(1);
			}
			checkInventoryQuantity('decrease');
		});


		jQuery('.product-single__meta .js-quantity-wrapper input[name="quantity"]').on('keyup, change', function (e) {
			var value = jQuery(this).val();
			$('.sticky-selector-wrapper .product-form__item--quantity .clone-product-form__input').val(value);
		});

		jQuery('.product-quantity-mobile-select select').on('change', function (e) {
			var thisVal = $(this).val();
			$(this).parent().siblings('.js-quantity-wrapper').find('input[type="number"]').val(thisVal);
			$(this).parent().siblings('.js-quantity-wrapper').find('input[type="number"]').text(thisVal);
		});


		// PDP Redesign JS
		$(function () {
			// Details section
			$('.details-title').on('click', function () {
				$(this).siblings('.details-content').slideToggle();
				$(this).closest('.product-details-item').toggleClass('open');
			});

			// Mobile sticky ATC
			if (document.querySelector('.sticky-atc-container')) {
				function isScrolledIntoView(elem) {
					let docViewTop = $(window).scrollTop() + 80; // Adjust for header height
					let docViewBottom = docViewTop + $(window).height();

					let elemTop = $(elem).offset().top;
					let elemBottom = elemTop + $(elem).height();

					return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
				}

				const toggleStickyAtc = () => {
					let item = $('.product-form__item--quantity');
					document.querySelector('.sticky-atc-container').style.display = '';

					if (isScrolledIntoView(item) === true) {
						$('.product-main-wrapper').removeClass('sticky_cta');
						return false;
					} else {
						$('.product-main-wrapper').addClass('sticky_cta');
						return true;
					}
				}

				window.removeEventListener('scroll', toggleStickyAtc, {passive: true});
				window.addEventListener('scroll', toggleStickyAtc, {passive: true});

				// Hide/show sticky ATC on swatch change
				if (toggleStickyAtc()) document.querySelector('.sticky-atc-container').style.display = '';
				else document.querySelector('.sticky-atc-container').style.display = 'none';

				// sticky CTA button
				document.querySelector('.sticky-addtocart-button').addEventListener('click', async e => {
					let selected = await document.querySelector('.product-form variant-selector').triggerDropdowns(true);
					if (selected) {
						e.target.classList.add('show-loading');
						await addToCart();
						e.target.classList.remove('show-loading');
					}
				});
			}

			// okendo review
			let totalReviewCount = $('.okeReviews-reviewsAggregate-summary-total').text();
			let getNumbersCount = totalReviewCount.replace(/\D/g, '');

			$('.okeReviews-reviewsAggregate-summary-total').text(`(${getNumbersCount})`);

			// whybedthreads tabs
			$('.tab-link').off().on('click', function () {
				let ID = $(this).attr('data-tab');
				let IntID = parseInt(ID);

				$(this).addClass('active').siblings().removeClass('active');
				$('#' + ID).addClass('active').siblings().removeClass('active');

				$('.card-is-slider').slick('slickGoTo', IntID);
			});

			// remove dummy slide in mobile
			if (window.innerWidth < 500) {
				$('.isDummy').remove();
			}

			// whybedthreads modal
			$('.modal-cta').off().on('click', function () {
				let name = $(this).data('name');

				$(".whybedthreads-container .learn-more-modal-container").fadeIn();
				$(`.whybedthreads-container .learn-more-modal-container .items[data-name="${name}"]`).addClass('active').siblings().removeClass('active');

				// mobile slide up modal
				if (window.innerWidth <= 768) {
					$(".whybedthreads-container .learn-more-modal-container .content-wrapper").addClass('open');
				}
			});

			$('.whybedthreads-content .image-wrapper').off().on('click', function () {
				$(this).parents('.card-item').find('.modal-cta').trigger('click');
			});

			$('.whybedthreads-container .close-overlay').off().on('click touchend', function () {
				$(".whybedthreads-container .learn-more-modal-container").fadeOut();
				// mobile slide up modal
				if (window.innerWidth <= 768) {
					$(".whybedthreads-container .learn-more-modal-container .content-wrapper").removeClass('open');
				}
			});

			$('.whybedthreads-container .close-icon').off().on('click', function () {
				$(".whybedthreads-container .close-overlay").trigger('click');
			});

			// Okendo swatch reload fix
            if (window.okeWidgetApi) {
                window.okeWidgetApi.initAllWidgets()
            }
		});

		// Check product stock inventory
		function checkInventoryQuantity(type) {
			let productForm = $('.product-form-product-template');
			let activeVariantInventory = parseInt(document.querySelector('.product-form-product-template select[name="id"]').selectedOptions[0].dataset.inventory);
			let currentInputValue = parseInt($('#Quantity-product-template').val());
			let currentName = $('.product-form .product-size__item.active').data('name');
			let productTitle = $('.product-single__meta .product-single__title').text();

			if (type == 'increase') {
				if (currentInputValue > activeVariantInventory && activeVariantInventory > 0) {
					let element = `<p class="inventory-message"><i class="fa fa-warning"></i> You can't add more ${currentName || productTitle} to the cart.</p>`;

					productForm.append(element);
					document.getElementById('AddToCart-product-template').disabled = true;
					$('.js-quantity-wrapper .increase.items').css('pointerEvents', 'none');
				}
			}

			if (type == 'decrease') {
				if (currentInputValue <= activeVariantInventory) {
					document.getElementById('AddToCart-product-template').disabled = false;
				}
				$('.js-quantity-wrapper .increase.items').css('pointerEvents', 'auto');
				$('.inventory-message').remove();
			}

			if (type == 'sizeChange') {
				if (currentInputValue < activeVariantInventory) {
					$('.js-quantity-wrapper .increase.items').css('pointerEvents', 'auto');
					$('.inventory-message').remove();
				}
			}
		}
	})();
}

// Legacy BNPL popup
$(document).on('click', '.bn-pl-popup .bg-close, .bn-pl-popup .cta-close-popup', function() {
	$('body').removeClass('bn-pl-popup-active');
});
$(document).on('click', '.bn-pl-wrapper .p-item-learnmore a', function(e) {
	e.preventDefault();
	var paymentType = $(this).parents().eq(1).attr('data-payment-type');
	console.log(paymentType);
	$('.bn-pl-popup .inner-wrapper .payment-item[data-name="'+paymentType+'"]').addClass('active').siblings().removeClass('active');
	$('body').addClass('bn-pl-popup-active');
});
$(document).on('click', '.bn-pl-wrapper .p-item-logo', function(e) {
	e.preventDefault();
	var paymentType = $(this).parent().attr('data-payment-type');
	console.log(paymentType);
	$('.bn-pl-popup .inner-wrapper .payment-item[data-name="'+paymentType+'"]').addClass('active').siblings().removeClass('active');
	$('body').addClass('bn-pl-popup-active');
});

initProductPage();
